import { atom } from "recoil";

import { WidgetTypeExtended } from "./models";

export enum WidgetUIState {
  RENDERED = "rendered",
  LOADING = "loading",
  NULL = "null",
}

export type WidgetStateReturn = {
  id: string;
  type: WidgetTypeExtended;
  state: WidgetUIState;
  elementCount?: number;
};

export const widgetStatesAtom = atom<WidgetStateReturn[]>({
  key: "WidgetSatesAtom",
  default: [],
});
